export default __webpack_public_path__ + "1a226b444423164d57714989c1ac145d.png";